import React from 'react'
import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import './menu.css'
import { Spinner } from '@/components/spinner'
import { useAppContext } from '@/context/app'

export interface MenuRow {
    icon?: string
    title: string
    action: () => void
}

export interface Menu {
    title?: string
    rows: MenuRow[]
}

interface MenuPopupBodyProps {
    menu: Menu
    session?: CurrentSession | undefined | null
    onClose: () => void
}

export function MenuPopupBody({ menu, onClose }: MenuPopupBodyProps) {
  const {translates, services, session} = useAppContext()

    const handleKeyDown = (e: React.KeyboardEvent, action: () => void) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            onClose()
            action()
        }
    };

    if(!translates) {
        return <Spinner />
    }

    return (
        <div className='menu-popup-body'>
            {menu.title && <h3>{translates.for(menu.title)}</h3>}
            <div className='list'>
                {menu.rows.map((row, idx) => (
                    <div
                        className='row'
                        key={row.title + idx}
                        onClick={() => {
                            onClose()
                            row.action()
                        }}
                        tabIndex={0}
                        role="button"
                        onKeyDown={(e) => handleKeyDown(e, row.action)}
                    >
                        {row.icon && <i className={row.icon} />}
                        <div className='title'>{translates.for(row.title)}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}
